import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ViewerWidgetWrapper } from './styled';
import Table from './Table';
import moment from 'moment';
import { chartIntervalSelector } from '@store/trends/birdChart/selectors';
import { tid } from '@utils/test';

function ImpactedViewers() {
  const interval: any = useSelector(chartIntervalSelector);

  // do not show viewers table for more than 24h within 30d
  const isIntervalInvalid = useMemo(() => {
    return (
      moment(interval.to).diff(moment(interval.from), 'hours') > 24 ||
      moment().diff(moment(interval.from), 'days') + 1 > 30
    );
  }, [interval]);

  if (isIntervalInvalid) {
    return (
      <div style={{ height: 200, margin: '20px 10px' }}>
        Impacted Viewers are only supported for 24 hour range within 30 days.
      </div>
    );
  }

  return (
    <ViewerWidgetWrapper {...tid('impacted-viewers')}>
      <Table />
    </ViewerWidgetWrapper>
  );
}

export default ImpactedViewers;
